<template>

	<div class="map"></div>

</template>

<script>

export default {
	props: ['marker', 'departure', 'arrival'],
	data () {
		return {
			resolveInitPromise: null,
			rejectInitPromise: null,
			initialized: true,
			maps_api: [],
			_marker: null
		};
	},
	computed: {
		isValid () {
			return this.departure && this.arrival;
		}
	},
	methods: {
		initPromise () {
			return new Promise((resolve, reject) => {
				this.resolveInitPromise = resolve;
				this.rejectInitPromise = reject;
			});
		},

		async gmapsInit () {
			const API_KEY = 'AIzaSyDQwgPqNeqBNKbb2KSa2FZMxQOoSZ8Vz6o';
			const CALLBACK_NAME = 'initMap';
			this.initialized = !!window.google;
			// If Google Maps already is initialized
			// the `initPromise` should be resolved
			// eventually.
			if (this.initialized) {
				/*global google */
				google.maps.event.trigger(window, 'resize', {});
				const geocoder = new google.maps.Geocoder();
				const map = new google.maps.Map(document.getElementsByClassName('map')[0], {
					zoom: 1,
					center: { lat: 0, lng: 0 }
				});
				if (this.marker) {
					const marker = await this.codeAddress(this.marker, geocoder);
					this._marker = new google.maps.Marker({
						position: marker.location,
						map
					});
					map.setCenter(marker.location);
					map.setZoom(10);
				} else {
					await this.createLine(google, map, geocoder);
				}
				this.maps_api = [google, geocoder, map];
				return this.initPromise();
			}
			this.initialized = true;
			// The callback function is called by the Google Maps script if it is successfully loaded.
			window[CALLBACK_NAME] = () => this.resolveInitPromise(window.google);
			const script = document.createElement('script');
			script.async = true;
			script.defer = true;
			script.type = 'text/javascript';
			script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}`;
			script.onerror = this.rejectInitPromise;
			script.onload = () => {
				this.gmapsInit();
			};
			document.querySelector('body').appendChild(script);
			return this.initPromise();
		},

		async codeAddress (address, geocoder) {
			return new Promise(function (resolve) {
				if (!geocoder) {
					geocoder = this.maps_api[1];
				}
				geocoder.geocode({ address: address }, async (results, status) => {
					if (status !== 'OK' || !results[0]) {
						throw new Error(status);
					}
					resolve(results[0].geometry);
				});
			});
		},

		async createLine (google, map, geocoder) {
			if (this.departure && this.arrival) {
				if (google === null || map === null || geocoder === null) {
					google = this.maps_api[0];
					geocoder = this.maps_api[1];
					map = this.maps_api[2];
				}
				const depart = await this.codeAddress(this.departure, geocoder);
				const arriv = await this.codeAddress(this.arrival, geocoder);
				if (this.path !== undefined) this.path.setMap(null);
				const flightPlanCoordinates = [depart.location, arriv.location];
				this.path = new google.maps.Polyline({
					path: flightPlanCoordinates,
					geodesic: true,
					strokeColor: '#4986E7',
					strokeOpacity: 1.0,
					strokeWeight: 2
				});
				this.path.setMap(map);
				this.addLocationCircles(google, map);
				//reset zoom on polyline
				const bounds = new google.maps.LatLngBounds();
				bounds.extend(depart.location);
				bounds.extend(arriv.location);
				map.setCenter(depart.location);
				map.fitBounds(bounds);
			}
		},

		addLocationCircles (google, map) {
			const path = this.path.getPath();
			const dep = path.getAt(0);
			const arr = path.getAt(1);
			if (this.dep_marker !== undefined) {
				this.dep_marker.setMap(null);
			}
			if (this.arr_marker !== undefined) {
				this.arr_marker.setMap(null);
			}
			this.dep_marker = new google.maps.Marker({
				position: dep,
				icon: {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 5,
					fillColor: '#F00',
					fillOpacity: 0.4,
					strokeWeight: 0.4
				},
				title: '#' + path.getLength(),
				map: map
			});
			this.arr_marker = new google.maps.Marker({
				position: arr,
				icon: {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 5,
					fillColor: '#F00',
					fillOpacity: 0.4,
					strokeWeight: 0.4
				},
				title: '#' + path.getLength(),
				map: map
			});
		}
	},
	async mounted () {
		try {
			await this.gmapsInit();
			const	google = this.maps_api[0];
			const	geocoder = this.maps_api[1];
			const	map = this.maps_api[2];
			if (this.marker) {
				const marker = await this.codeAddress(this.marker, geocoder);
				this._marker = new google.maps.Marker({
					position: marker.location,
					map
				});
				map.setCenter(marker.location);
			} else {
				await this.createLine(google, map, geocoder);
			}
		} catch (error) {
		}
	},
	watch: {
		async marker () {
			const	geocoder = this.maps_api[1];
			const	map = this.maps_api[2];
			const marker = await this.codeAddress(this.marker, geocoder);
			this._marker.setMap(null);
			this._marker = new google.maps.Marker({
				position: marker.location,
				map
			});
			map.setCenter(marker.location);
		},
		async departure () {
			await this.gmapsInit();
		},
		async arrival () {
			await this.gmapsInit();
		}
	}
};

</script>

<style>

.map {
		width: 100%;
		height: 100%;
}

</style>
